<template>
	<v-number-input v-model="numberValue" controlVariant="split" :label="props.label" :min="props.min" :max="props.max" :step="props.step" :precision="props.precision" inset clearable density="compact" variant="outlined"></v-number-input>
</template>

<script setup>
// #region Imports

import { shallowRef, computed } from 'vue';

// #endregion

// #region Refs & Vars

const props = defineProps({
	label: { type: String, default: '' },
	min: { type: Number, default: 1 },
	max: { type: Number, default: 9999 },
	step: { type: Number, default: 1 },
	precision: { type: Number, default: 0 },
});

const numberValue = shallowRef(null);
const filterIsDirty = computed(() => {
	return numberValue.value !== null;
});

// #endregion

// #region Methods

defineExpose({
	getValue() {
		return numberValue.value !== null ? numberValue.value : null;
	},
	isDirty() {
		return filterIsDirty.value;
	},
	selectItems(items) {
		numberValue.value = items;
	},
});

// #endregion
</script>
